<template>
    <div>
        <v-card flat>
            <v-toolbar flat dense>
                <v-toolbar-title>Customers Activities</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn class="mx-1" icon @click="refresh">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu offset-y :close-on-content-click="false" v-model="display.search">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <CustomerActivitySearchMenu :loading="loading.data" :close="!loading.data" @submit="onCustomerActivitySearchMenuSubmit" />
                </v-menu>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item @click="openActivityDialog()" link>
                            <v-list-item-icon>
                                <v-icon>mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("New Activity") }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-card-text>
                <!-- <v-row>
                    <v-col cols="12" md="3">
                        <dashboard-box icon="mdi-email-open-outline" color="white" background-color="grey darken-2" content-color="white" title="Open Activities" value="20" outlined> </dashboard-box>
                    </v-col>
                    <v-col cols="12" md="3">
                        <dashboard-box icon="mdi-face-profile" color="white" content-color="white" background-color="success" title="Opened Today" value="10" outlined> </dashboard-box>
                    </v-col>
                    <v-col cols="12" md="3">
                        <dashboard-box icon="mdi-close-octagon" color="white" content-color="white" background-color="red lighten" title="Overdue Activities" value="13" outlined> </dashboard-box>
                    </v-col>
                    <v-col cols="12" md="3">
                        <dashboard-box icon="mdi-check" color="white" content-color="white" background-color="blue" title="Completed" value="10" outlined> </dashboard-box>
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col>
                        <v-data-table :headers="headers" :items="activities" :options.sync="options" dense :server-items-length="totalActivites" :loading="loading.data" @updated="fetchCustomerActivites">
                            <template v-slot:[`item.code_f`]="{ item }">
                                <a href="#" @click="openCustomerActivityDisplay(item)">{{ item.code_f }}</a>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ formatDate(item.created_at) }}
                            </template>
                            <template v-slot:[`item.updated_at`]="{ item }">
                                {{ formatDate(item.updated_at) }}
                            </template>
                            <template v-slot:[`item.state`]="{ item }">
                                <p-status :state="item.state"></p-status>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <customer-activity-edit v-if="customerActivityShown" v-model="customerActivityShown" @created="handleCreated"> </customer-activity-edit>
        <customer-activity-display v-if="customerActivityDisplayShown" v-model="customerActivityDisplayShown" :activity="selectedActivity" :customer="customer" @update="fetchCustomerActivites"> </customer-activity-display>

        <v-dialog v-model="loading.wait" width="350" persistent>
            <v-card flat>
                <div class="text-center d-flex flex-column justify-center align-center pa-2" style="height: 100%">
                    <v-progress-linear height="4" indeterminate> </v-progress-linear>
                    <div class="text-body-1 pa-2">Please Wait ...</div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
// import DashboardBox from "../../components/common/DashboardBox";
import { getCustomerActivities } from "../../services/sales/customerActivity";
import { searchUsers } from "../../services/administration/user";
import PStatus from "../../components/common/PStatus.vue";
import CustomerActivitySearchMenu from "../../components/Sales/CustomerActivitySearchMenu";
import CustomerActivityDisplay from "../../components/Sales/CustomerActivityDisplay";
import CustomerActivityEdit from "../../components/Sales/CustomerActivityEdit.vue";
// import { getCustomer } from "../../services/sales/customer";
import { mapState } from 'vuex';

export default {
    components: {
        // DashboardBox,
        PStatus,
        CustomerActivitySearchMenu,
        CustomerActivityDisplay,
        CustomerActivityEdit,
    },
    name: "CustomerActivities",
    data() {
        return {
            headers: [
                { text: "Number", value: "code_f", sortable: false },
                { text: "Type", value: "type", sortable: false },
                { text: "Touch Point", value: "touch_point", sortable: false },
                { text: "Created", value: "created_at", sortable: false },
                { text: "Customer", value: "customer.display_name", sortable: false },
                { text: "Last Updated", value: "updated_at", sortable: false },
                { text: "Assinged To", value: "assignee", sortable: false },
                { text: "State", value: "state", sortable: false },
            ],
            loading: {
                data: false,
                wait: false,
            },
            totalActivites: 0,
            activities: [],
            display: {
                search: false,
            },
            search: {
                status: "OPEN",
                assignee_id: null
            },
            options: {},
            customerActivityShown: false,
            customerActivityDisplayShown: false,
            selectedActivity: null,
            customer: null,
        };
    },
    computed: {
        ...mapState("authentication", ["loggedInUser"])
    },
    watch: {
        options: {
            handler() {
                this.fetchCustomerActivites();
            },
            deep: true,
        },
    },
    methods: {
        async fetchCustomerActivites() {
            this.loading.data = true;
            let response = await getCustomerActivities({ ...this.options, ...this.search });
            this.activities = response.data.data;
            this.totalActivites = response.data.total;
            this.loading.data = false;
        },
        onCustomerActivitySearchMenuSubmit(search) {
            this.search = search;
            this.fetchCustomerActivites();
        },
        async getUserById(userId) {
            let response = await searchUsers({ user_id: userId });
            console.log(response);
        },
        refresh() {
            this.fetchCustomerActivites();
        },
        formatDate(date) {
            return moment(date).fromNow();
        },
        async openCustomerActivityDisplay(activity) {
            this.loading.wait = true;
            // let response = await getCustomer(activity.customer_id);
            // this.customer = response.data;
            this.customer = activity.customer;

            this.selectedActivity = activity;
            this.loading.wait = false;
            this.customerActivityDisplayShown = true;
        },
        openActivityDialog() {
            this.customerActivityShown = true;
        },
        handleCreated(activity) {
            console.log(activity);
        },
    },
    mounted() {
        this.fetchCustomerActivites(/**{ status:'OPEN' }**/);
    },
    created() {
        this.search.assignee_id = this.loggedInUser.id;
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
    color: black;
    font-weight: bold;
}
a:hover {
    text-shadow: 0.5px 1px grey;
}
</style>
